import { createSignal, onCleanup, onMount } from "solid-js";


export const Loader = () => (<div class="loader"></div>);


export const NavDropdown = (props) => {

    const [showMenu, setShowMenu] = createSignal(false);
    let menuDropdown;
    let dropdownElement;

    const handleToggleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(!showMenu());
    };

    const handleOutsideClick = (event) => {
        // Close menu when clicking outside
        if (dropdownElement && !dropdownElement.contains(event.target)) {
            setShowMenu(false);
        }
    };

    onMount(() => {
        document.addEventListener('click', handleOutsideClick);
    });
    onCleanup(() => {
        document.removeEventListener('click', handleOutsideClick);
    });

    return <li class={"nav-item dropdown"+(showMenu() ? ' show':'')} ref={dropdownElement}>
      <a 
        ref={menuDropdown}
        class="nav-link dropdown-toggle" 
        href="#" 
        id="navbarDropdownMenuLink" 
        role="button" 
        onClick={handleToggleClick}
        aria-expanded={showMenu() ? "true" : "false"}>
        {props.label}
      </a>
      <ul class={"dropdown-menu"+(showMenu() ? ' show':'')} aria-labelledby="navbarDropdownMenuLink">
        {props.children}
      </ul>
    </li>;
}